import React, { useState } from "react";
import { HeroiconsOutlineCalendar } from "../../assets/icons/LayoutIcon";

const SubFilterComponent = ({
  fields,
  onApply,
  onReset,
  handleClose,
  openFilter,
}) => {
  const [filters, setFilters] = useState({});
  const [fromDateValue, setFromDateValue] = useState("");
  const [isFromDateFocused, setIsFromDateFocused] = useState(false);
  const [toDateValue, setToDateValue] = useState("");
  const [isToDateFocused, setIsToDateFocused] = useState(false);

  const handleFilterChange = (id, value) => {
    setFilters((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleApply = () => {
    console.log("items", filters);
    if (onApply) {
      onApply(filters);
    }
  };

  const handleReset = () => {
    setFilters({});
    setFromDateValue("");
    setToDateValue("");
    onReset && onReset();
  };

  const renderField = (field) => {
    switch (field.type) {
      case "date":
        if (field.id === "fromDate") {
          return (
            <div key={field.id} className="flex items-center gap-2">
              <div className="relative">
                <div className="absolute inset-y-0 left-0 px-2 bg-gray-50 border border-gray-300 rounded-tl-md rounded-bl-md flex items-center">
                  <HeroiconsOutlineCalendar className="text-md text-gray-500" />
                </div>
                <div className="pl-9">
                  <div className="relative w-full">
                    {!fromDateValue && !isFromDateFocused && (
                      <div className="absolute inset-0 flex items-center pl-3 pointer-events-none text-gray-400 text-sm">
                        Start Date
                      </div>
                    )}
                    <input
                      type={
                        fromDateValue || isFromDateFocused ? "date" : "text"
                      }
                      value={fromDateValue}
                      onChange={(e) => {
                        setFromDateValue(e.target.value);
                        handleFilterChange("fromDate", e.target.value);
                      }}
                      onFocus={() => setIsFromDateFocused(true)}
                      onBlur={() => setIsFromDateFocused(false)}
                      onClick={() => setIsFromDateFocused(true)}
                      className="w-48 lg:w-36 custom-dateinput border rounded-r-md border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 appearance-none date-input-no-indicator"
                      max={toDateValue || undefined}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        } else if (field.id === "toDate") {
          return (
            <div key={field.id} className="flex items-center gap-2">
              <div className="relative">
                <div className="absolute inset-y-0 left-0 px-2 bg-gray-50 border border-gray-300 rounded-tl-md rounded-bl-md flex items-center">
                  <HeroiconsOutlineCalendar className="text-md text-gray-500" />
                </div>
                <div className="pl-9">
                  <div className="relative w-full">
                    {!toDateValue && !isToDateFocused && (
                      <div className="absolute inset-0 flex items-center pl-3 pointer-events-none text-gray-400 text-sm">
                        End Date
                      </div>
                    )}
                    <input
                      type={toDateValue || isToDateFocused ? "date" : "text"}
                      value={toDateValue}
                      onChange={(e) => {
                        setToDateValue(e.target.value);
                        handleFilterChange("toDate", e.target.value);
                      }}
                      onFocus={() => setIsToDateFocused(true)}
                      onBlur={() => setIsToDateFocused(false)}
                      onClick={() => setIsToDateFocused(true)}
                      className="w-48 lg:w-36 custom-dateinput border rounded-r-md border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 appearance-none date-input-no-indicator"
                      min={fromDateValue || undefined}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        }
        return null;

      default:
        return null;
    }
  };

  const Content = () => (
    <div className="grid grid-cols-1 sm:grid-cols-2 items-center gap-3 ">
      {fields.map(renderField)}
    </div>
  );

  return (
    <div>
      {/*  large Screen*/}
      <div className="hidden lg:block ">
        <div className="flex justify-start items-center gap-3 pl-4 ">
          <Content />
          <div className="items-center">
            <button onClick={handleApply} className="text-white bg-primary px-4 py-2 rounded-md">
              Filter
            </button>
          </div>
        </div>
      </div>
      {/*  mobile  Screen */}
      <div className="lg:hidden block">
        {openFilter && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
            onClick={handleClose}
          >
            <div
              className="bg-white p-6 rounded-3xl w-[80vw] shadow-xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="space-y-4">
                <div>
                  <h2 className="text-2xl text-text1 font-bold">Filters</h2>
                  <hr className="text-gray-200 mt-3" />
                </div>
                <Content />

                <div className="flex justify-end space-x-2">
                  <button
                    onClick={handleReset}
                    className="border rounded-md px-3 py-1 bg-white"
                  >
                    Reset
                  </button>
                  <button
                    onClick={handleApply}
                    className="bg-primary text-white rounded-md px-3 py-1 hover:bg-primary"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubFilterComponent;
